export const checkWindow = (): boolean => typeof window !== 'undefined';
